import { CALL_API } from 'redux-api-middleware'
import { DATA_LOAD_FAILURE } from './loading'
import { constructEndpoint, constructQueries, sorted  } from '../utils/helpers'
import { PARTNER_REQUEST } from './user'
import { RESET_DIALOG_STATE } from './formDialog'

export const GROUPS_REQUEST = 'group/GROUPS_REQUEST'
export const GROUPS_RECEIVE = 'group/GROUPS_RECEIVE'
export const GROUPS_FAILURE = 'group/GROUPS_FAILURE'
export const GROUP_FILTERED_PARTNERS_REQUEST = 'group/GROUP_FILTERED_PARTNERS_REQUEST'
export const GROUP_FILTERED_PARTNERS_RECEIVE = 'group/GROUP_FILTERED_PARTNERS_RECEIVE'
export const GROUP_FILTERED_PARTNERS_FAILURE = 'group/GROUP_FILTERED_PARTNERS_FAILURE'
export const GROUP_USERS_REQUEST = 'group/GROUP_USERS_REQUEST'
export const GROUP_USERS_RECEIVE = 'group/GROUP_USERS_RECEIVE'
export const GROUP_USERS_FAILURE = 'group/GROUP_USERS_FAILURE'
export const GROUP_ROLES_REQUEST = 'group/GROUP_ROLES_REQUEST'
export const GROUP_ROLES_RECEIVE = 'group/GROUP_ROLES_RECEIVE'
export const GROUP_ROLES_FAILURE = 'group/GROUP_ROLES_FAILURE'
export const SINGLE_GROUP_REQUEST = 'group/SINGLE_GROUP_REQUEST'
export const SINGLE_GROUP_RECEIVE = 'group/SINGLE_GROUP_RECEIVE'
export const SINGLE_GROUP_FAILURE = 'group/SINGLE_GROUP_FAILURE'
export const GROUP_PATCH_DIALOG_REQUEST = 'group/GROUP_PATCH_DIALOG_REQUEST'
export const GROUP_PATCH_DIALOG_RECEIVE = 'group/GROUP_PATCH_DIALOG_RECEIVE'
export const GROUP_PATCH_DIALOG_FAILURE = 'group/GROUP_PATCH_DIALOG_FAILURE'
export const GROUP_PROFILE_REQUEST = 'group/GROUP_PROFILE_REQUEST'
export const GROUP_PROFILE_RECEIVE = 'group/GROUP_PROFILE_RECEIVE'
export const GROUP_PROFILE_FAILURE = 'group/GROUP_PROFILE_FAILURE'
export const GROUP_POST_DIALOG_REQUEST = 'group/GROUP_POST_DIALOG_REQUEST'
export const GROUP_POST_DIALOG_RECEIVE = 'group/GROUP_POST_DIALOG_RECEIVE'
export const GROUP_POST_DIALOG_FAILURE = 'group/GROUP_POST_DIALOG_FAILURE'
export const GROUP_PUT_DIALOG_REQUEST = 'group/GROUP_PUT_DIALOG_REQUEST'
export const GROUP_PUT_DIALOG_RECEIVE = 'group/GROUP_PUT_DIALOG_RECEIVE'
export const GROUP_PUT_DIALOG_FAILURE = 'group/GROUP_PUT_DIALOG_FAILURE'
export const GROUP_DELETE_DIALOG_REQUEST = 'group/GROUP_DELETE_DIALOG_REQUEST'
export const GROUP_DELETE_DIALOG_RECEIVE = 'group/GROUP_DELETE_DIALOG_RECEIVE'
export const GROUP_DELETE_DIALOG_FAILURE = 'group/GROUP_DELETE_DIALOG_FAILURE'
export const GROUP_USER_DELETE_DIALOG_REQUEST = 'group/GROUP_USER_DELETE_DIALOG_REQUEST'
export const GROUP_USER_DELETE_DIALOG_RECEIVE = 'group/GROUP_USER_DELETE_DIALOG_RECEIVE'
export const GROUP_USER_DELETE_DIALOG_FAILURE = 'group/GROUP_USER_DELETE_DIALOG_FAILURE'
export const GROUP_ROLE_DELETE_DIALOG_REQUEST = 'group/GROUP_ROLE_DELETE_DIALOG_REQUEST'
export const GROUP_ROLE_DELETE_DIALOG_RECEIVE = 'group/GROUP_ROLE_DELETE_DIALOG_RECEIVE'
export const GROUP_ROLE_DELETE_DIALOG_FAILURE = 'group/GROUP_ROLE_DELETE_DIALOG_FAILURE'
export const TAB_STATE_CHANGE = 'group/TAB_STATE_CHANGE'


const initialState = {
  groupProfile: {},
  groups: [],
  groupsFilteredByPartner: [],
  tabState: 0,
  totalCount: 0
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GROUP_FILTERED_PARTNERS_RECEIVE:
      return {
        ...state,
        groupsFilteredByPartner: action.payload.data.items
      }
    case GROUPS_RECEIVE:
      return {
        ...state,
        groups: sorted(action.payload.data.items),
        totalCount: action.payload.data.totalCount
      }
    case GROUP_PROFILE_FAILURE:
      return {
        ...state,
        groupProfile: null
      }
    case TAB_STATE_CHANGE:
      return {
        ...state,
        tabState: action.tabState
      }
    case GROUP_USER_DELETE_DIALOG_RECEIVE:
      const filteredGroupUsers = state.groupProfile.users.filter(user => {
        return user.id !== action.meta.deletedGroupUserId
      })
      return {
        ...state,
        groupProfile: {
          ...state.groupProfile,
          users: filteredGroupUsers
        }
      }
    case GROUP_POST_DIALOG_RECEIVE:
      var updatedGroups = [...state.groups]
      updatedGroups.unshift({...action.payload.data.item, mappings:[], users:[]})
      return {
        ...state,
        groups: sorted(updatedGroups)
      }
    case GROUP_PUT_DIALOG_RECEIVE:
      const updated = [...state.groups].map(group => {
        if (group.id === action.payload.data.item.id) {
          const groupUsers = group.users
          group = action.payload.data.item
          group.users = groupUsers
        }
        return group
      })
      return {
        ...state,
        groups: sorted(updated)
      }
    case GROUP_PATCH_DIALOG_RECEIVE:
      updatedGroups = state.groups.map(group => {
        if (group.id === action.meta.groupId && action.meta.user) {
          group.users.push(action.meta.user[0].id)
        }
        return group
      })
      var updatedProfile = {...state.groupProfile}
      if (updatedProfile.group && updatedProfile.group.id === action.meta.groupId) {
        action.meta.user ?
        updatedProfile.users.push(cleanGroupUsers(action.meta.user)[0]):
        action.meta.newRoles.forEach(role => {
          updatedProfile.roles.push(role)
        })
      }
      return {
        ...state,
        groups: sorted(updatedGroups),
        groupProfile: updatedProfile
      }
    case GROUP_ROLE_DELETE_DIALOG_RECEIVE:
      updatedProfile = {...state.groupProfile, roles: state.groupProfile.roles.filter(role => {
        return role.id !== action.meta.id
      })}
      return {
        ...state,
        groupProfile: updatedProfile
      }
    case GROUP_DELETE_DIALOG_RECEIVE:
      const newGroups = state.groups.filter(group => {
        return group.id !== action.meta.id
      })
      return {
        ...state,
        groups: newGroups
      }
    case GROUP_PROFILE_RECEIVE:
      return {...state, groupProfile: action.data}
    case PARTNER_REQUEST: // if a user closes dialog or types in a new partnerId this
    case RESET_DIALOG_STATE:  // will clear the filtered partners
    return {
      ...state,
      groupsFilteredByPartner: []
    }
    default:
      return state
  }
}

export function fetchGroupProfile(id) {
  return (dispatch) => {
    dispatch({type: GROUP_PROFILE_REQUEST})
    return Promise.all([
      dispatch(fetchSingleGroup(id)),
      dispatch(fetchGroupUsers(id)),
      dispatch(fetchGroupRoles(id)),
    ])
    .then(response => {
      let profile = {}
      response.forEach(groupData => {
        const fetchName = groupData.type.split('_')[1].toLowerCase()
        if (groupData.error) {
          profile.error = true
          profile[fetchName] = []
        }
        else if (fetchName === 'users') {
          profile.users = cleanGroupUsers(groupData.payload.data.items)
        }
        else {
          profile[fetchName] = groupData.payload.data.item ? groupData.payload.data.item : groupData.payload.data.items
        }
      })
      if (profile.error === true) {
        dispatch({type: GROUP_PROFILE_FAILURE})
        dispatch({type: DATA_LOAD_FAILURE})
      } else {
        return dispatch({
          type: GROUP_PROFILE_RECEIVE,
          data: profile
        })
      }
    })
  }
}

export function fetchGroups(isRefreshRequired) {
  return (dispatch, getState) => {
    const queries = constructQueries(getState(), 'group')

    return dispatch({
      [CALL_API]: {
        endpoint: constructEndpoint('/api/v1/authz/groups', queries.join(''), isLocal()),
        method: 'GET',
        credentials: 'include',
        types: [GROUPS_REQUEST,
          {
            type: GROUPS_RECEIVE,
            meta: { isRefreshRequired : isRefreshRequired ? true : false }
          },
          {
            type: GROUPS_FAILURE,
            meta: { isRefreshRequired : isRefreshRequired ? true : false }
          }
        ]
      }
    })
  }
}

export function fetchSingleGroup(groupId) {
  return {
    [CALL_API]: {
      endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/groups/${groupId}` :
        `/api/v1/authz/groups/${groupId}`,
      method: 'GET',
      credentials: 'include',
      types: [SINGLE_GROUP_REQUEST, SINGLE_GROUP_RECEIVE, SINGLE_GROUP_FAILURE]
    }
  }
}

export function fetchGroupsFilteredByPartner(partner) {
  return {
    [CALL_API]: {
      endpoint: constructEndpoint(`/api/v1/authz/partners/${partner.id}/groups`, `partnerIds=${partner.id}`, isLocal()),
      method: 'GET',
      credentials: 'include',
      types: [GROUP_FILTERED_PARTNERS_REQUEST, GROUP_FILTERED_PARTNERS_RECEIVE, GROUP_FILTERED_PARTNERS_FAILURE]
    }
  }
}

export function fetchGroupUsers(groupId) {
  return {
    [CALL_API]: {
      endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/groups/${groupId}/users` :
        `/api/v1/authz/groups/${groupId}/users`,
      method: 'GET',
      credentials: 'include',
      types: [GROUP_USERS_REQUEST, GROUP_USERS_RECEIVE, GROUP_USERS_FAILURE]
    }
  }
}

export function fetchGroupRoles(groupId) {
  return {
    [CALL_API]: {
      endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/groups/${groupId}/roles` :
        `/api/v1/authz/groups/${groupId}/roles`,
      method: 'GET',
      credentials: 'include',
      types: [GROUP_ROLES_REQUEST, GROUP_ROLES_RECEIVE, GROUP_ROLES_FAILURE]
    }
  }
}

export function postGroup(formValues, partnerName) {
  const { applicationId, name, description, partnerId, roleIds } = formValues
  let bodyData = {
    name,
    description,
    partner: { name: partnerName, id: partnerId },
    applicationId,
    roleIds
  }
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/groups` :
          `/api/v1/authz/groups`,
        method: 'POST',
        body: JSON.stringify(bodyData),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [GROUP_POST_DIALOG_REQUEST, GROUP_POST_DIALOG_RECEIVE, GROUP_POST_DIALOG_FAILURE]
      }
    })
  }
}

export function putGroup(formValues) {
  const { applicationId,
    id,
    description,
    name,
    partner,
    roleIds } = formValues

  const bodyData = {
    applicationId,
    description,
    name,
    partner,
    roleIds }

  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/groups/${id}` :
          `/api/v1/authz/groups/${id}`,
        method: 'PUT',
        body: JSON.stringify(bodyData),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [GROUP_PUT_DIALOG_REQUEST, GROUP_PUT_DIALOG_RECEIVE, GROUP_PUT_DIALOG_FAILURE]
      }
    })
  }
}

export function patchGroupUsers(formValues, user) {
  const newUserId = formValues.newUsers
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/groups/${formValues.id}/users` :
          `/api/v1/authz/groups/${formValues.id}/users`,
        method: 'PUT',
        body: JSON.stringify({ids: [newUserId]}),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [GROUP_PATCH_DIALOG_REQUEST,
          {
            type: GROUP_PATCH_DIALOG_RECEIVE,
            meta: {groupId: formValues.id, user}
          },
          GROUP_PATCH_DIALOG_FAILURE]
      }
    })
  }
}

export function patchGroupRoles(groupId, newRoles) {
  const roleIds = newRoles.map(role => role.id)
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/groups/${groupId}/roles` :
          `/api/v1/authz/groups/${groupId}/roles`,
        method: 'PUT',
        body: JSON.stringify({ids: roleIds}),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [GROUP_PATCH_DIALOG_REQUEST,
          {
            type: GROUP_PATCH_DIALOG_RECEIVE,
            meta: {groupId, newRoles}
          },
          GROUP_PATCH_DIALOG_FAILURE]
      }
    })
  }
}

export function removeGroup(group) {
  const { id } = group
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/groups/${id}` :
          `/api/v1/authz/groups/${id}`,
        method: 'DELETE',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [GROUP_DELETE_DIALOG_REQUEST,
          {
            type: GROUP_DELETE_DIALOG_RECEIVE,
            meta: { id }
          },
          GROUP_DELETE_DIALOG_FAILURE]
      }
    })
  }
}

export function deleteGroupUsers(groupId, groupUserIdToDelete) {
  // TODO: BROKEN - Needs API Change - See NID-806
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/groups/${groupId}/users` :
          `/api/v1/authz/groups/${groupId}/users`,
        method: 'DELETE',
        body: JSON.stringify({ids: [groupUserIdToDelete]}),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [
          GROUP_USER_DELETE_DIALOG_REQUEST,
          {
            type: GROUP_USER_DELETE_DIALOG_RECEIVE,
            meta: { deletedGroupUserId: groupUserIdToDelete}
          },
          GROUP_USER_DELETE_DIALOG_FAILURE
        ]
      }
    })
  }
}

export function deleteGroupRoles(groupId, groupRoleId) {
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/groups/${groupId}/roles` :
          `/api/v1/authz/groups/${groupId}/roles`,
        method: 'DELETE',
        body: JSON.stringify({ids: [groupRoleId]}),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [GROUP_ROLE_DELETE_DIALOG_REQUEST,
          {
              type: GROUP_ROLE_DELETE_DIALOG_RECEIVE,
              meta: {id: groupRoleId}
          },
          GROUP_ROLE_DELETE_DIALOG_FAILURE]
      }
    })
  }
}

export const cleanGroupUsers = (users) => {
  return users.reduce((result, user) => {
    if (user !== null && (user.username || user.email)) {
      result.push({
        name: user.name ? user.name.split('@')[0] : user.username || user.email,
        username: user.username || user.email,
        id: user.id
      })
    }
    return result
  }, [])
}

export const changeTabState = (tabState) => ({type: TAB_STATE_CHANGE, tabState})

function isLocal() {
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
}

export default reducer
